import type { ReactNode } from 'react'
import { SiteHeader } from './SiteHeader'
import { SiteFooter } from './SiteFooter'

export function PageShell({ children }: { children: ReactNode }) {
  return (
    <div className="shell">
      <SiteHeader />
      <main id="main-content" className="shell-main">{children}</main>
      <SiteFooter />
    </div>
  )
}
